import PropTypes from 'prop-types';
import React from 'react';
import getSendingEmployeeName from 'src/components/Dashboard/utils/getSendingEmployeeName';
import ReferralRowIcon from 'src/components/Dashboard/components/Referrals/ReferralRowIcon';
import { DynamicTable } from 'common/tables';
import { shapes } from '@unite-us/client-utils';
import { Spinner } from 'common/spinners';
import _ from 'lodash';
import FilterBar from '../FilterBar';
import { programColumn } from '../../utils/columnConfigs/baseColumns';

const SERVICE_AUTH_REJECTED_BY = 'Utilization Manager';

function getColumns(setSort, sortConfig, showProgramNameColumn) {
  const lastUpdatedColumn = {
    label: 'Last Updated',
    sortColumn: 'updated_at',
    type: 'date',
  };

  if (setSort && sortConfig) {
    lastUpdatedColumn.sortBy = sortConfig?.sidx;
    lastUpdatedColumn.sortDirection = sortConfig?.sord;
    lastUpdatedColumn.setSort = ({ sortBy }) => setSort(sortBy);
  }

  return [
    {
      label: 'Sent by',
      sortColumn: 'sent_by',
    },
    {
      label: 'Rejected By',
      sortColumn: 'rejected_by',
    },
    {
      label: 'Client Name',
      sortColumn: 'contact.full_name',
    },
    {
      label: 'Service Type',
      sortColumn: 'service_type.name',
    },
    ...(showProgramNameColumn ? [programColumn('referred_to_program.name', sortConfig, setSort)] : []),
    lastUpdatedColumn,
  ];
}

function populateSentByField(referrals) {
  return referrals.map((referral) => {
    const sent_by = getSendingEmployeeName(referral);
    return { ...referral, sent_by };
  });
}

function populateRejectedByField(referrals) {
  return referrals.map((referral) => {
    const rejected_by = referral.state === 'denied_authorization' ?
      (referral?.rejector?.provider?.name || SERVICE_AUTH_REJECTED_BY) : referral.referred_to_group.name;
    return { ...referral, rejected_by };
  });
}

export function RejectedReferralsIndex(props) {
  const {
    paging,
    data,
    onNextClick,
    onPrevClick,
    isFetching,
    onCellClick,
    initialSort,
    filters,
    onFiltersChange,
    fetchGroupsUsers,
    sortConfig,
    setSort,
    showProgramNameColumn,
  } = props;
  return (
    <div>
      <FilterBar
        filters={filters}
        onFiltersChange={onFiltersChange}
        paging={paging}
        onNextClick={onNextClick}
        onPrevClick={onPrevClick}
        isFetching={isFetching && !_.isEmpty(data)}
        asyncSearch={fetchGroupsUsers}
      />
      <div className="dashboard-inner-content">
        {
          (isFetching && _.isEmpty(data)) ?
            <Spinner /> : (
              <DynamicTable
                caption="Rejected referrals"
                id="rejected-referrals-table"
                dataSet={populateSentByField(populateRejectedByField(data))}
                onCellClick={onCellClick}
                initialSort={initialSort}
                columnLabels={getColumns(setSort, sortConfig, showProgramNameColumn)}
                emptyMessage="There are no rejected referrals."
                rowIcon={(referral) => <ReferralRowIcon referral={referral} />}
              />
            )
        }
      </div>
    </div>
  );
}

RejectedReferralsIndex.propTypes = {
  isFetching: PropTypes.bool.isRequired,
  data: PropTypes.array.isRequired,
  paging: shapes.paging,
  onNextClick: PropTypes.func.isRequired,
  onPrevClick: PropTypes.func.isRequired,
  onCellClick: PropTypes.func.isRequired,
  initialSort: PropTypes.object,
  filters: PropTypes.array,
  onFiltersChange: PropTypes.func,
  fetchGroupsUsers: PropTypes.func.isRequired,
  sortConfig: PropTypes.func,
  setSort: PropTypes.object,
  showProgramNameColumn: PropTypes.bool,
};

RejectedReferralsIndex.defaultProps = {
  sortConfig: null,
  setSort: null,
  showProgramNameColumn: false,
};

export default RejectedReferralsIndex;
